import * as React from 'react';
import Page from './Page';
import ConceptManagementCore from './core/ConceptManagementCore';
import { UserRoleEnum } from '../redux/UserSlice';
import { useAppSelector, useAppDispatch } from '../hooks/index';
import { setIsDirty, isAdmin } from '../redux/MiscSlice';
import { TaxonomyTypeEnum } from '../redux/TaxonomyVersionSlice';




const FundAccountCodeManagement = (props: any) => {
    const isAdminUser: boolean = useAppSelector(isAdmin);

    return (
        <React.Fragment>
            <Page>
                <ConceptManagementCore taxonomyType={TaxonomyTypeEnum.AFR} />
            </Page>
        </React.Fragment>
    );
}

export default FundAccountCodeManagement;